import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth APIs
export const authAPI = {
  register: (userData) => api.post('/auth/register', userData),
  login: (credentials) => api.post('/auth/login', credentials),
  getProfile: () => api.get('/auth/profile'),
  updateProfile: (userData) => api.put('/auth/profile', userData),
  changePassword: (passwords) => api.put('/auth/change-password', passwords)
};

// Course APIs
export const coursesAPI = {
  getMyCourses: () => api.get('/courses/my-courses'),
  getCourseLessons: (courseId) => api.get(`/courses/course/${courseId}/lessons`),
  completeLesson: (lessonId) => api.post(`/courses/lesson/${lessonId}/complete`),
  getProgress: () => api.get('/courses/progress'),
  getLessonVideoUrl: (lessonId) => api.get(`/courses/lesson/${lessonId}/video-url`),
  getPackages: () => api.get('/courses/packages')
};

export default api;
